import { useEffect, useRef, useState } from "react";
import { AirhelpLogo } from "styles/logos";
import {
  ChakraBox as Box,
  ChakraImage as Image,
  ChakraAspectRatio as AspectRatio,
  ChakraSkeleton as Skeleton,
} from "@airhelp/react-ui-components";
import type { PostListImageProps } from "./PostListImage.d";

const PostListImage = ({ src, alt }: PostListImageProps) => {
  const imageRef = useRef<HTMLImageElement>(null);
  const [isImageReady, setIsImageReady] = useState(false);

  useEffect(() => {
    if (!isImageReady && imageRef.current?.complete) {
      setIsImageReady(true);
    }
  }, [isImageReady]);

  return src ? (
    <Skeleton isLoaded={isImageReady} rounded="xl" startColor="greyscale.200" endColor="greyscale.400">
      <AspectRatio ratio={19 / 12} mb={4}>
        <Image ref={imageRef} src={src} onLoad={() => setIsImageReady(true)} objectFit="cover" rounded="xl" alt={alt} />
      </AspectRatio>
    </Skeleton>
  ) : (
    <AspectRatio ratio={19 / 12} mb={4}>
      <Box bgColor="primary.900" rounded="xl" sx={{ ".chakra-icon": { w: "42%", h: "22%" } }}>
        <AirhelpLogo color="white" />
      </Box>
    </AspectRatio>
  );
};

export default PostListImage;
